import React from "react";
import { Slide, Paper, Card, Divider, Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import PhysicianNameComponent from "./common/PhysicianNameComponent";
import DateDisplay from "./common/DateDisplay";
import DiagnosisList from "./patient/DiagnosisList";
import RequestAccessToken from '../util/authService';
import EncounterList from './patient/EncounterList'
import { useHistory } from "react-router-dom";
import { practiceCoordinatorLoaded } from './common/ProfileHelper'
import DocumentsIndex from './patient/DocumentIndex'

import './style.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import PatientDischargeDisplay from "./patient/PatientDischargeDisplay";
import { formatDate } from './common/DateHelper'
import PatientRoomDisplay from "./patient/PatientRoomDisplay"
import PatientMedicalRecordsIndex from "./patient/PatientMedicalRecordsIndex";
import PatientSplitButton from "./AI/PatientSplitButton";
import PatientMenuButton from './AI/PatientMenuButton';


type PatientsByIdProps = {
    FocusPatient: APIStore.FocusPatientState,
    apiHost: string,
    userPracticeCoordinatorProfile: APIStore.PracticeCoordinatorState,
    userRefMdProfile: APIStore.RefMDProfileState
} &
    typeof APIStore.actionCreators &
    RouteComponentProps<{ PtId: string }>;


const Patient = (props: PatientsByIdProps) => {
    let {
        requestConsolidatedPatientById,
        FocusPatient,
        requestMessageContactsForPractice,
        requestMessageContactsUser,
        requestCurrentUserCareCoordinatorProfile,
        apiHost
    } = props;

    let userPracticeCoordinatorProfile: APIStore.PracticeCoordinatorState = props.userPracticeCoordinatorProfile;
    let userRefMdProfile: APIStore.RefMDProfileState = props.userRefMdProfile;

    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    const history = useHistory();

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    useEffect(() => {
        let ptidNumber = parseInt(props.match.params.PtId) || 0;
        if (tokenState?.accessToken) {
            requestConsolidatedPatientById(ptidNumber, tokenState.accessToken);
        }

    }, [tokenState]);


    useEffect(() => {
        if (tokenState && !practiceCoordinatorLoaded(userPracticeCoordinatorProfile) && !userPracticeCoordinatorProfile.notFound) {
            requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);
        }

        if (userPracticeCoordinatorProfile.notFound) {
            requestMessageContactsUser(tokenState?.accessToken)
        }

        if (userPracticeCoordinatorProfile.isLoaded) {
            requestMessageContactsForPractice(tokenState?.accessToken, userPracticeCoordinatorProfile.coordinatorProfile?.defaultPractice.practiceId);
        }
    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile]);

    if (!FocusPatient || FocusPatient.isLoading || !(FocusPatient ?? patient.encounters)) {
        return (
            <Slide in timeout={500} direction="left">
                <div className="maincontent">
                    <Grid container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={3}>
                        <Grid item>
                            <div className="skeleton skeleton-text">
                                &#8239; &#8239; &#8239; &#8239; &#8239;
                            </div>
                        </Grid>
                        <Grid item>
                            <div className=" skeleton skeleton-text">
                                &#8239; &#8239; &#8239; &#8239; &#8239;
                            </div>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={3}
                    >
                        <Grid xs={4} item>
                            <Typography variant="body1" component="div" gutterBottom>
                                <div className="skeleton skeleton-text">
                                    <p>&#8239;&#8239;&#8239; &#8239;</p>
                                </div>
                            </Typography>
                        </Grid>
                        <Grid xs={4} item>
                            <Typography variant="body1" component="div" gutterBottom>
                                <div className="skeleton skeleton-text">
                                    <p>&#8239;&#8239;&#8239; &#8239;</p>
                                </div>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={2}
                    >
                        <Grid xs={3} item>
                            <Typography variant="body1" component="div" gutterBottom>
                                <div className="skeleton skeleton-text">
                                    <p>&#8239;&#8239;&#8239; &#8239;</p>
                                </div>
                            </Typography>
                        </Grid>
                        <Grid xs={3} item>
                            <Typography variant="body1" component="div" gutterBottom>

                                <div className="skeleton skeleton-text">
                                    <p>&#8239;&#8239;&#8239;&#8239;</p>
                                </div>

                            </Typography>
                        </Grid>
                        <Grid xs={3} item>
                            <Typography variant="body1" component="div" gutterBottom>
                                <div className="skeleton skeleton-text">
                                    <p>&#8239;&#8239;&#8239;&#8239;</p>
                                </div>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Typography variant="body1" component="div" gutterBottom>
                        <div className="skeleton skeleton-text">
                            <p>&#8239;&#8239;&#8239;&#8239;</p>
                        </div>
                    </Typography>
                    <Typography variant="body1" component="div" gutterBottom>
                        <div className="skeleton skeleton-text">
                            <p>&#8239;&#8239;&#8239;&#8239;</p>
                        </div>
                    </Typography>
                    <EncounterList isLoading={true} encounters={null} />
                </div>
            </Slide>
        )
    }

    let {
        firstName,
        lastName,
        mrn,
        policyNumber,
        drgDesc,
        referringMDName,
        encounters,
        patientEncounterId,
        historicalMedicalRecords
    }: APIStore.Patient = FocusPatient.patient;

    let encounter = encounters[0];

    let { primaryProviderContact, encounterInsurance, patientDiagnosisList, dateOfBirth, downloadablePatientDocuments, daysToDischarge, roomNumber, patientMedicalRecords, facility }: APIStore.Encounter = encounter;

    let companyNameFromFacility = 'N/A';

    if (encounterInsurance) {
        companyNameFromFacility = encounterInsurance.companyNameFromFacility
    }
    
    return (
        <Slide in timeout={500} direction="left">
            <div className="maincontent" style={{ padding: 24 }}>

                <Typography variant="overline" component="div" gutterBottom>
                    {facility.facilityName}
                </Typography>

                <Typography variant="h5" component="div" gutterBottom>
                    {lastName}, {firstName}
                    <PatientMenuButton ptId={props.match.params.PtId} />
                </Typography>
                <Grid container spacing={2}>
                    <Grid item>
                        <Typography variant="body1" component="div" gutterBottom>
                            <DateDisplay
                                DateValue={formatDate(encounter.encounterStart, false)}
                                DateNullText="UNAVAIL"
                                Label="Admitted"
                            />
                        </Typography>
                    </Grid>
                    <PatientDischargeDisplay encounter={encounter} />
                    <Grid item>
                        <Typography variant="body1" component="div" gutterBottom>
                            <strong>MRN:{" "}</strong>
                            <Typography variant="body2" component="span" gutterBottom="100">
                                {mrn}
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" component="div" gutterBottom>
                            <strong>Policy No:{" "}</strong>
                            <Typography variant="body2" component="span" gutterBottom="100">
                                {policyNumber}
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" component="div">
                            <DateDisplay
                                DateValue={formatDate(dateOfBirth, true)}
                                DateNullText="UNAVAIL"
                                Label="DOB"
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" component="div" gutterBottom>
                            <Typography variant="body2" component="span" gutterBottom="100">
                                {

                                    <PhysicianNameComponent patientEncounterId={patientEncounterId} ProviderContact={primaryProviderContact} />
                                }
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" component="div" gutterBottom>
                            <strong>Insurance:{" "}</strong>
                            <Typography variant="body2" component="span">
                                {companyNameFromFacility}
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" component="div" gutterBottom>
                            <Typography variant="body2" component="span" gutterBottom="100">
                                {

                                    <PatientRoomDisplay encounter={encounter} />
                                }
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider component="div" />
                    </Grid>
                    <Grid item xs={12}>
                        <DiagnosisList diagnosisCodes={patientDiagnosisList} listLabel='Diagnosis' />
                    </Grid>
                    <Grid item xs={12}>
                        <DocumentsIndex  downloadablePatientDocuments={downloadablePatientDocuments} apiHost={apiHost} />
                        <PatientMedicalRecordsIndex historicalMedicalRecords={historicalMedicalRecords} patientMedicalRecords={patientMedicalRecords} />
                    </Grid>

                    <Grid item xs={12}>
                        <EncounterList isLoading={false} encounters={encounters} />
                    </Grid>



                </Grid>
            </div>
        </Slide>
    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(Patient as any);